import { Component, OnInit, Input} from '@angular/core';
import { Enums } from 'src/app/_models/generatedEnums';
import { AssessmentDetailViewModel, AssessmentResult, AssessmentType, StringViewModel } from 'src/app/_models/generatedModels';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentService } from 'src/app/_services/generatedServices';
import { AssessmentPDFDialogComponent } from '../assessment-pdf-dialog/assessment-pdf-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { ToasterService } from '../../_services/toaster.service';
import { ExerciseToolTipModalComponent } from '../../coaches-admin/Clients/assessments/exercise-tool-tip-modal.component';
import { SettingsProvider } from '../../_services/settingsProvider.service';

@Component({
  selector: 'assessment-result-details',
  templateUrl: 'assessment-result-details.component.html',
  styleUrls: ['assessment-result-details.component.scss']
})
export class AssessmentResultDetailsComponent implements OnInit {
  initialized = false;
  programUrl: string = '/library/programs/view';

  shareableLink: string;
  assessment: AssessmentDetailViewModel;
  ImpairmentCategoryEnum = Enums.ImpairmentCategoryEnum;
  MovementCategoryEnum = Enums.MovementCategoryEnum;
  AssessmentResultEnum = Enums.AssessmentResultEnum;
  RRAssessmentResultShortEnum = Enums.RRAssessmentResultShortEnum;
  assessmentType = AssessmentType;
  rraProgramDescription: string;

  @Input()
  isCoachView: boolean = false;

  @Input()
  isPrintVersion: boolean = false;

  @Input()
  assessmentId: any;

  @Input()
  isShared: boolean = false;

  constructor(private route: ActivatedRoute, private settingsProvider: SettingsProvider, private assessmentData: AssessmentService, private modalService: NgbModal, private router: Router, private toastr: ToasterService) {}

  ngOnInit(): void {
    // this view is used in two ways, so we need to check if the assessmentId was passed in
    if (!this.assessmentId) {
      this.assessmentId = this.route.snapshot.params ? this.route.snapshot.params['id'] : null;
    }
    if (this.isShared) {

      const model = new StringViewModel();
      model.value = this.assessmentId;

      this.assessmentData.getAssessmentDetailsByGuid(model).subscribe((result) => {
        this.assessment = result;

        if (result.program?.description) {
          this.rraProgramDescription = this.htmlToText(result.program?.description);
        }

        this.initialized = true;

      },
        (err: HttpErrorResponse) => {
          if (err && err.error && err.error.indexOf('UnauthorizedAccessException') >= 0) {
            this.toastr.error('You do not have access to the assessment', 'Error',);
          } else {
            this.toastr.error('An error occurred while loading the assessment', 'Error');
          }

          this.router.navigate(['../../../'], { relativeTo: this.route });

        });

      return;
    }

    this.assessmentData.getAssessmentDetails(this.assessmentId).subscribe((result) => {
      this.assessment = result;

      if (result.program?.description) {
        this.rraProgramDescription = this.htmlToText(result.program?.description);
      }

      this.shareableLink = this.settingsProvider.siteUrl + '/rra-assessment/' + this.assessment.uniqueIdentifier;
      this.initialized = true;     
    },
      (err: HttpErrorResponse) =>
      {
        if (err && err.error && err.error.indexOf('UnauthorizedAccessException') >= 0) {
          this.toastr.error('You do not have access to the assessment', 'Error',);
        } else {
          this.toastr.error('An error occurred while loading the assessment', 'Error');
        }

        this.router.navigate(['../../../'], { relativeTo: this.route });

      });
  }

  htmlToText(html: string)
  {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  showHelp(key: string)
  {
    const modalRef = this.modalService.open(ExerciseToolTipModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.key = key;
    modalRef.result.then(
      (result) => { },
      (reason) => { }
    );
  }

  getAssessmentValue(sectionName: string, categoryName: string, subCategoryName: string): AssessmentResult {
    var section = this.assessment.sections.find(s => s.sectionName == sectionName);
    var category = section.categoryResults.find(r => r.category.name == categoryName)
    var subCategory = category.subCategories.find(s => s.name == subCategoryName)

    var result = 0;

    if (subCategoryName && !subCategory) {
      result = 1; // On backend we dont create subcategory if the value is "Able""
    }
    else {
      result = subCategory ? subCategory.assessmentResult : category.category.assessmentResult
    }

    // Mapping AssessmentResult to RRAssessmentResultShortEnum
    if (result == AssessmentResult.ActiveLimitation || result == AssessmentResult.PassiveLimitation) {
      result = AssessmentResult.Unable;
    }

    // Mapping AssessmentResult to RRAssessmentResultShortEnum
    if (result == AssessmentResult.ActiveLimitationWithPain || result == AssessmentResult.PassiveLimitationWithPain) {
      result = AssessmentResult.UnableWithPain;
    }

    return result;
  }

  onPrintPDF() {
    const modalRef = this.modalService.open(AssessmentPDFDialogComponent, { size: 'lg', windowClass: 'modal-max-xl-custom' });
    modalRef.componentInstance.assessmentId = this.assessmentId;
    modalRef.componentInstance.assessmentType = this.assessmentType.RRA;
    modalRef.result.then(
      (result) => {},
      (reason) => {}
    );
  }

  onCopyLink()
  {
    //copy link to clipboard
    let link = document.createElement('textarea');
    link.value = this.shareableLink;
    document.body.appendChild(link);
    link.select();
    document.execCommand('copy');
    document.body.removeChild(link);
    this.toastr.success('Link copied to clipboard', 'Success');
  }

}
